/** 来源仅用于判断业务权限；比较时与后端保持去空格、忽略大小写，绝不回写或归类原值。 */
export function normalizeEnterpriseSource(source?: string | null): string {
  return (source || '').trim().toLowerCase()
}

/** 只有 MDM 主档适用整组只读规则，其他集成或历史空来源沿用原有权限。 */
export function isMdmEnterpriseSource(source?: string | null): boolean {
  return normalizeEnterpriseSource(source) === 'mdm'
}

/** 主表来源尚未读取成功时关闭写入口，避免从未加载状态推断为可维护。 */
export function canMaintainEnterpriseSource(source: string | null | undefined, sourceLoaded: boolean): boolean {
  return sourceLoaded && !isMdmEnterpriseSource(source)
}
